export enum SoundNotification {
  IncomingChat = 'incoming_chat',
  QueuedVisitor = 'queued_visitor',
  Message = 'message',
  NewVisitor = 'new_visitor',
  ReturningVisitor = 'returning_visitor',
  NewTicket = 'ticket',
}
